import type EntryOf from 'types/EntryOf';

export interface Object {
  entriesTS<T extends object>(object: T): EntryOf<T>[];
  entriesTS<K extends PropertyKey, V>(object: Partial<Record<K, V>>): [K, V][];
  fromEntriesTS<K extends string | number | symbol, V>(entries: readonly (readonly [K, V])[]): Record<K, V>;
  fromEntriesTSAll<K extends string | number | symbol, V>(entries: readonly (readonly [K, V])[]): Record<K, V>;
  fromEntriesPartial<T extends object>(entries: ReadonlyArray<EntryOf<T>>): Partial<T>;
  keysTS<K extends string | number | symbol>(object: Record<K, unknown>): K[];
}

Object.defineProperty(Object.prototype, 'entriesTS', {
  enumerable: false,
  value: function <T extends object>(object: T) {
    return Object.entries(object) as unknown as EntryOf<T>[];
  },
});

Object.defineProperty(Object.prototype, 'fromEntriesTS', {
  enumerable: false,
  value: function <K extends string | number | symbol, V>(
    entriesOrMap: readonly (readonly [K, V])[] | { [P in K]: readonly [P, V] }
  ) {
    const entries = Array.isArray(entriesOrMap) ? entriesOrMap : Object.values(entriesOrMap);
    return Object.fromEntries(entries);
  },
});

Object.defineProperty(Object.prototype, 'fromEntriesTSAll', {
  enumerable: false,
  value: function <K extends string | number | symbol, V>(
    entriesOrMap: readonly (readonly [K, V])[] | { [P in K]: readonly [P, V] }
  ) {
    const entries = Array.isArray(entriesOrMap) ? entriesOrMap : Object.values(entriesOrMap);
    return Object.fromEntries(entries);
  },
});

Object.defineProperty(Object.prototype, 'fromEntriesPartial', {
  enumerable: false,
  value: function <T extends object>(entries: ReadonlyArray<EntryOf<T>>) {
    return Object.fromEntries(entries) as Partial<T>;
  },
});

Object.defineProperty(Object.prototype, 'keysTS', {
  enumerable: false,
  value: function <K extends string | number | symbol>(object: Record<K, unknown>) {
    return Object.keys(object) as K[];
  },
});
